import { Button, Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';
import { SelectMultiDepartment } from "../../../../components/selects";
import { useState } from 'react';
import SelectGovernment from '../../../../components/selects/SelectGovernment';

interface IProps {
    formField: any;
    form: any;
    onReset: () => void;
    onSearch: () => void;
}

export const FilterPosition = (props: IProps) => {
    const { t } = useTranslation();
    const [selectedGovernment, setSelectedGovernment] = useState<number | null>(null);
    return (
        <Form form={props.form} layout='vertical'>
            <Row gutter={10}>
                <Col span={6}>
                    <Form.Item
                        label={t('general.name')}
                        name={props.formField.name}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        label={t('Организация')}
                        name={props.formField.governmentId}
                    >
                        <SelectGovernment
                            value={selectedGovernment}
                            onChange={(id) => {
                                setSelectedGovernment(id);
                            }}
                        />
                    </Form.Item>
                </Col>
                { selectedGovernment !== null ?
                    <Col span={6}>
                        <Form.Item
                            label={t('titles.departments')}
                            name={props.formField.departmentIds}
                        >
                            <SelectMultiDepartment 
                            governmentIds={selectedGovernment !== null ? [selectedGovernment] : null}
                            />
                        </Form.Item>
                    </Col>
                    : ""
                }

                <Col span={6}>
                    <div style={{ marginTop: 30 }}>
                        <Button
                            type="primary"
                            shape="default"
                            size="middle"
                            icon={<SearchOutlined />}
                            style={{ marginRight: 'auto' }}
                            onClick={props.onSearch}
                        >{t('general.search')}</Button>
                        <Button
                            size="small"
                            type="link"
                            onClick={props.onReset}
                            style={{ color: "orange" }}
                        >{t('general.reset')}</Button>
                    </div>
                </Col>
            </Row>
        </Form>
    )
}
